import { Button, Input, Popconfirm, Space, Switch, message } from 'antd'
import React from 'react'
import API from '../../../../utils/api'
import { useToken } from '../../../hooks'

const SettingChange = ({ data, mutate = () => {} }) => {
	const type = data?.id?.split('_')[1]?.split(':')[0]
	const { data: token } = useToken()

	return (
		<Space.Compact>
			<Popconfirm
				title="삭제하시겠습니까?"
				onConfirm={() => {
					API.send('DELETE', '/admin/pc', token + '', {
						pc: data?.key,
					}).then(res => {
						message.success('삭제되었습니다.')
						mutate()
					})
				}}>
				<Button type="primary" size="small">
					삭제
				</Button>
			</Popconfirm>
		</Space.Compact>
	)
}

export default React.memo(SettingChange)
